var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrebroHockey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Namnl\xF6s_\xF6vertoning_2);}.cls-2{fill:url(#Namnl\xF6s_\xF6vertoning_2-2);}.cls-3{fill:#fff;}.cls-4{fill:none;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Namnl\\xF6s_\\xF6vertoning_2",
    cx: 99.7,
    cy: 102,
    r: 104.67,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 201.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#e4032b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#d70728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#b60c21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d0e1a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Namnl\\xF6s_\\xF6vertoning_2-2",
    cx: 99.7,
    cy: 102,
    r: 105.13,
    xlinkHref: "#Namnl\\xF6s_\\xF6vertoning_2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_2",
    "data-name": "Lager 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lager_1-2",
    "data-name": "Lager 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lager_1-3",
    "data-name": "Lager 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.14,170.62H102.57V1.05H177v43H153.36L177,67.68v68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.47,170.62H57.86L23,135.68v-68L46.64,44.05H23v-43H97.43V170.62Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "toning"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "28.73 6.16 28.81 38.02 60.72 38.02 28.73 69.53 28.73 132.9 60.41 164.59 92.1 164.59 92.1 6.16 28.73 6.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "171.32 6.16 171.23 38.02 139.28 38.02 171.32 69.53 171.32 132.9 139.63 164.59 107.94 164.59 107.94 6.16 171.32 6.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vit_ram",
    "data-name": "Vit ram"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.86,167.54h-35.2V4.13H174V41H146l28,28V134.4Zm-30.23-5h28.16L169,132.33V71L133.91,36H169V9.1h-58.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.39,167.54H59.18L26,134.4V69l28-28H26V4.13H94.34V167.54Zm-33.18-5H89.37V9.1H31V36H66.13L31,71v61.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 31.85,
    y: 164.5,
    width: 137.75,
    height: 29.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,171.28c-6.34,0-10.35,4.8-10.35,10.83,0,5.76,3.57,10.6,10,10.6S55,188.44,55,181.8C55,176.25,51.66,171.28,45,171.28Zm-3.39-.75a2.35,2.35,0,0,0,2.29-2.37,2.29,2.29,0,0,0-2.29-2.34,2.34,2.34,0,0,0-2.42,2.34,2.37,2.37,0,0,0,2.42,2.37Zm3.3,5.15c2.68,0,4.27,2.73,4.27,6.29,0,3.75-1.59,6.34-4.27,6.34s-4.36-2.42-4.36-6.29S42.24,175.68,44.88,175.68Zm3.34-5.15a2.35,2.35,0,0,0,2.29-2.37,2.33,2.33,0,1,0-4.66,0,2.33,2.33,0,0,0,2.37,2.37ZM60.77,192.4h5.5v-7.79h.88c1.71,0,2.51.53,3,3a27.55,27.55,0,0,0,1.46,4.75h5.67c-.39-.79-1.1-3.82-1.71-5.94-.53-1.8-1.28-3.12-2.64-3.69v-.14a5.49,5.49,0,0,0,3.56-5,5.41,5.41,0,0,0-2.07-4.54c-1.58-1.18-3.87-1.58-7-1.58a44.28,44.28,0,0,0-6.73.44V192.4Zm5.5-16.72a11.39,11.39,0,0,1,1.89-.13c1.85,0,2.86.88,2.86,2.46s-1.19,2.6-3.3,2.6H66.27Zm29.44,3.83H88.27v-3.35h7.92v-4.53H82.68V192.4H96.59v-4.57H88.23V184h7.44v-4.49Zm7,12.76a36.41,36.41,0,0,0,5.5.35c4.45,0,7-.7,8.59-1.89A5.5,5.5,0,0,0,119,186.2a5.09,5.09,0,0,0-4-5.06v0c2.42-.92,3.38-2.64,3.38-4.35a4.65,4.65,0,0,0-2.81-4.27c-1.63-.84-3.39-1-6.34-1a46.41,46.41,0,0,0-6.56.44v20.37Zm5.5-16.72a11.46,11.46,0,0,1,1.81-.13c1.89,0,2.81.79,2.81,2s-1.14,2.15-3.52,2.15h-1.1Zm0,8h1.32c2.12,0,3.7.66,3.7,2.42s-1.58,2.55-3.43,2.55c-.71,0-1.19,0-1.59,0v-4.93Zm16.68,8.84h5.5v-7.79h.88c1.72,0,2.51.53,3,3a28.9,28.9,0,0,0,1.45,4.75h5.68c-.39-.79-1.06-3.82-1.72-5.94-.52-1.8-1.27-3.12-2.64-3.69v-.14a5.48,5.48,0,0,0,3.57-5,5.41,5.41,0,0,0-2.07-4.54c-1.58-1.18-3.87-1.58-7-1.58a44.28,44.28,0,0,0-6.73.44V192.4Zm5.5-16.72a11.67,11.67,0,0,1,1.9-.13c1.85,0,2.86.88,2.86,2.46s-1.19,2.6-3.3,2.6h-1.46Zm25.49-4.4c-6.34,0-10.35,4.8-10.35,10.83,0,5.76,3.52,10.6,10,10.6s10.43-4.27,10.43-10.91C165.9,176.25,162.52,171.28,155.83,171.28Zm-.09,4.4c2.68,0,4.27,2.73,4.27,6.29,0,3.75-1.59,6.34-4.27,6.34s-4.36-2.42-4.36-6.29S153.05,175.68,155.74,175.68ZM177,199.05H23V162.52H177v36.53Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 200,
    height: 200
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrebroHockey);
export default __webpack_public_path__ + "static/media/orebro-hockey.9eaa301fb4a52c4c8e6aac50df83f088.svg";
export { ForwardRef as ReactComponent };